import styled from 'styled-components/macro'

export const AppContainerStyled = styled.div`
  min-height: 100vh;
`
